import React, { useEffect, useState } from "react";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import Carousel from "react-multi-carousel";
import { useNavigate, useParams } from "react-router-dom";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url } from "../../../utils/modules";
import { Trans } from "react-i18next";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const PlanLoading = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      if (percent < 100) {
        setPercent(percent + 1);
      } else {
        setTimeout(() => {
          navigate(`/${params.gender}/emailForm`);
        }, 100);
      }
    }, 100);
  }, [percent]);

  return (
    <>
      <MobileViewLayout>
        <div>
          <div
            className="text-center main-padding d-flex flex-column px-0"
            style={{
              minHeight: "100dvh",
              paddingTop: "30px",
              paddingBottom: "45px",
            }}
          >
            <div style={{ flex: 1 }}>
              <div className="progressbar-container">
                <CircularProgressbarWithChildren
                  strokeWidth={10}
                  value={percent}
                  styles={{
                    path: {
                      strokeLinecap: "round",
                      stroke: "#2680EB",
                      width: "100px",
                    },
                    text: {
                      fill: "#000000",
                      fontSize: "22px",
                      fontWeight: "bolder",
                    },
                    trail: {
                      stroke: "#D6D6D6",
                    },
                  }}
                  className="custom-progress-bar"
                >
                  <div>
                    <strong style={{ fontSize: "50px" }}>{percent}</strong>
                    <span style={{ fontSize: "20px", fontWeight: "600" }}>
                      %
                    </span>
                  </div>
                </CircularProgressbarWithChildren>
              </div>
              <div className="d-flex flex-column ">
                <p
                  className="pt-3"
                  style={{
                    fontSize: "16px",
                  }}
                >
                  <Trans i18nKey={"designing_plan.title"} />
                </p>

                <hr className="align-self-center" style={{ width: "90%" }} />
                <h2
                  className="fw-bold px-3"
                  style={{ fontSize: "25px", color: "#4286F5" }}
                >
                  <Trans i18nKey={"designing_plan.people_chosen"} />
                </h2>
                <p
                  className="px-3"
                  style={{ fontSize: "18px", fontWeight: "bold" }}
                >
                  <Trans i18nKey={"designing_plan.chosen_freelanz_app"} />
                </p>
              </div>
              <Carousel
                draggable={true}
                showDots={false}
                responsive={responsive}
                autoPlay={true}
                autoPlaySpeed={3000}
                arrows={false}
                itemClass="px-3"
                sliderClass="d-flex flex-row"
                containerClass="carousel-container"
              >
                <div
                  className="p-3 user-select-none"
                  style={{
                    minHeight: "170px",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #D6D6D6",
                    borderRadius: "10px",
                  }}
                >
                  <div className="star-rating pb-3 ">
                    <img src={addS3Url("/loading/star.svg")} alt="" />
                  </div>
                  <div className="active">
                    <div className="">
                      <div
                        className="d-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <p
                          className="mb-0 "
                          style={{ fontSize: "14px", fontWeight: "700" }}
                        >
                          <Trans
                            i18nKey={
                              "designing_plan.exploring_financial_freedom"
                            }
                          />
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#6C6E79",
                            marginRight: "5px",
                          }}
                        >
                          <Trans i18nKey={"testimonials.sean.name"} />
                        </p>
                      </div>
                      <p
                        className="mb-0"
                        style={{
                          lineHeight: "20px",
                          fontSize: "12px",
                          color: "#6C6E79",
                          textAlign: "start",
                        }}
                      >
                        <Trans i18nKey={"testimonials.sean.text"} />
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="p-3 user-select-none"
                  style={{
                    minHeight: "170px",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #D6D6D6",
                    borderRadius: "10px",
                  }}
                >
                  <div className="star-rating pb-3 ">
                    <img src={addS3Url("/loading/star.svg")} alt="" />
                  </div>
                  <div className="active">
                    <div className="">
                      <div
                        className="d-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <p
                          className="mb-0 "
                          style={{ fontSize: "14px", fontWeight: "700" }}
                        >
                          <Trans i18nKey={"designing_plan.essential_guide"} />
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#6C6E79",
                            marginRight: "5px",
                          }}
                        >
                          <Trans i18nKey={"testimonials.angel.name"} />
                        </p>
                      </div>
                      <p
                        className="mb-0"
                        style={{
                          lineHeight: "20px",
                          fontSize: "12px",
                          color: "#6C6E79",
                          textAlign: "start",
                        }}
                      >
                        <Trans i18nKey={"testimonials.angel.text"} />
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="p-3 user-select-none"
                  style={{
                    minHeight: "170px",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #D6D6D6",
                    borderRadius: "10px",
                  }}
                >
                  <div className="star-rating pb-3 ">
                    <img src={addS3Url("/loading/star.svg")} alt="" />
                  </div>
                  <div className="active">
                    <div className="">
                      <div
                        className="d-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <p
                          className="mb-0 "
                          style={{ fontSize: "14px", fontWeight: "700" }}
                        >
                          <Trans i18nKey={"designing_plan.great_discovery"} />
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#6C6E79",
                            marginRight: "5px",
                          }}
                        >
                          <Trans i18nKey={"testimonials.trisha.name"} />
                        </p>
                      </div>
                      <p
                        className="mb-0"
                        style={{
                          lineHeight: "20px",
                          fontSize: "12px",
                          color: "#6C6E79",
                          textAlign: "start",
                        }}
                      >
                        <Trans i18nKey={"testimonials.trisha.text"} />
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="p-3 user-select-none"
                  style={{
                    minHeight: "170px",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #D6D6D6",
                    borderRadius: "10px",
                  }}
                >
                  <div className="star-rating pb-3 ">
                    <img src={addS3Url("/loading/star.svg")} alt="" />
                  </div>
                  <div className="active">
                    <div className="">
                      <div
                        className="d-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <p
                          className="mb-0 "
                          style={{ fontSize: "14px", fontWeight: "700" }}
                        >
                          <Trans
                            i18nKey={
                              "designing_plan.exploring_financial_freedom"
                            }
                          />
                        </p>
                        <p style={{ fontSize: "12px", color: "#6C6E79" }}>
                          <Trans i18nKey={"testimonials.sean.name"} />
                        </p>
                      </div>
                      <p
                        className="mb-0"
                        style={{
                          lineHeight: "20px",
                          fontSize: "12px",
                          color: "#6C6E79",
                          textAlign: "start",
                        }}
                      >
                        <Trans i18nKey={"testimonials.sean.text"} />
                      </p>
                    </div>
                  </div>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </MobileViewLayout>
    </>
  );
};

export default PlanLoading;
